import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ZafaraFullLogo } from "@/components/landing/Logo";
import { Footer } from "@/components/landing/Footer";
import { useContent } from "@/context/ContentContext";
import { SEO } from "@/components/SEO";

const Info = ({ label, value }) => (
  <p>
    <strong>{label} :</strong> {value || <span className="text-[#16241B]/40">— à compléter</span>}
  </p>
);

export default function MentionsLegales() {
  const { content } = useContent();
  const c = content.company;
  const f = content.founder;

  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#16241B]">
      <SEO
        title="Mentions légales & confidentialité"
        description="Mentions légales, politique de confidentialité et conditions d'utilisation du site Zafara Bénin — édité par Whilsco-Digit SARL."
        path="/mentions-legales"
        noindex
      />
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FBFAF6]/90 border-b border-[#EDE7D9]">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="hover:-translate-y-0.5 transition-transform">
            <ZafaraFullLogo />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-[#EDE7D9] bg-white px-4 py-2 text-sm font-medium hover:border-[#0E7A3B] hover:text-[#0E7A3B] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 sm:px-8 py-16 md:py-24">
        <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
          Informations légales
        </p>
        <h1 className="mt-4 font-display text-4xl md:text-5xl text-[#16241B] leading-[1.05] tracking-tighter">
          Mentions légales
          <br />
          <span className="text-[#0E7A3B]">& confidentialité.</span>
        </h1>

        <div className="mt-14 space-y-14">
          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
              Éditeur du site
            </h2>
            <div className="mt-4 rounded-2xl border border-[#EDE7D9] bg-white p-6 space-y-2 text-[#16241B]/85">
              <Info label="Raison sociale" value={`Whilsco-Digit ${c.form || ""}`.trim()} />
              <Info label="Siège social" value={c.siege} />
              <Info label="RCCM" value={c.rccm} />
              <Info label="IFU" value={c.ifu} />
              <Info label="Directeur de la publication" value={f.name} />
              <Info label="Email" value={c.email} />
              <p><strong>Marque :</strong> Zafara est une marque de Whilsco-Digit.</p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
              Hébergeur
            </h2>
            <div className="mt-4 rounded-2xl border border-[#EDE7D9] bg-white p-6 space-y-2 text-[#16241B]/85">
              <Info label="Hébergeur" value={c.hebergeur} />
            </div>
          </section>

          <section id="confidentialite">
            <h2 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
              Politique de confidentialité
            </h2>
            <div className="mt-4 rounded-2xl border border-[#EDE7D9] bg-white p-6 space-y-4 text-[#16241B]/85 leading-relaxed">
              <p>
                Les informations recueillies via le formulaire de contact du site
                sont transmises à Whilsco-Digit uniquement pour répondre à votre
                demande. Elles sont conservées pendant une durée maximale de 24
                mois et ne sont ni cédées, ni vendues à des tiers.
              </p>
              <p>
                Conformément à la réglementation en vigueur au Bénin et à la
                RGPD lorsqu'elle s'applique, vous disposez d'un droit d'accès,
                de rectification et de suppression de vos données. Pour
                l'exercer : {c.email || "contact"}.
              </p>
              <p>
                Le site utilise des cookies techniques strictement nécessaires
                à son fonctionnement. Aucun cookie publicitaire n'est déposé.
              </p>
            </div>
          </section>

          <section id="cgu">
            <h2 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
              Conditions d'utilisation
            </h2>
            <div className="mt-4 rounded-2xl border border-[#EDE7D9] bg-white p-6 space-y-4 text-[#16241B]/85 leading-relaxed">
              <p>
                Ce site vitrine présente l'application mobile Zafara. Son
                accès et son utilisation sont libres et gratuits. La
                reproduction, même partielle, des contenus (textes, marques,
                logos, illustrations) sans accord écrit de Whilsco-Digit est
                interdite.
              </p>
              <p>
                Les liens vers les magasins d'applications (App Store, Google
                Play) redirigent vers des services tiers non gérés par
                Whilsco-Digit ; leurs propres conditions s'appliquent.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-2xl md:text-3xl text-[#16241B] tracking-tight">
              Crédits
            </h2>
            <div className="mt-4 rounded-2xl border border-[#EDE7D9] bg-white p-6 space-y-2 text-[#16241B]/85">
              <p>Design & développement : Whilsco-Digit.</p>
              <p>Typographies : Bricolage Grotesque, Plus Jakarta Sans, Space Grotesk (Google Fonts).</p>
              <p>Icônes : Lucide.</p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
